var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"full-bleed"},[_c('cld-video',{attrs:{"cloud-name":"tobiasgerhardsson-com","autoplay":"true","loop":"true","muted":"true","playsinline":"","public-id":_vm.videoURL,"autoplayMode":"on-visible","quality":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }